<template>
    <div id="ag-grid-demo">
        <vx-card>
            <!-- TABLE ACTION ROW -->
            <div class="flex flex-wrap justify-between items-center">
                <!-- ITEMS PER PAGE -->
                <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
                    <vs-dropdown vs-trigger-click class="cursor-pointer">
                        <div
                                class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
                        >
              <span
                      class="mr-2"
              >{{ currentPage * limit - (limit - 1) }} - {{ dataCount - currentPage * limit > 0 ? currentPage * limit : dataCount }} of {{ dataCount }}</span>
                            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
                        </div>
                        <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
                        <vs-dropdown-menu id="ddl-page-limit">
                            <vs-dropdown-item id="ddl-page-limit-1" @click="callComponentFetchData(1, 20)">
                                <span>20</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item id="ddl-page-limit-2" @click="callComponentFetchData(1, 50)">
                                <span>50</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item id="ddl-page-limit-3" @click="callComponentFetchData(1, 100)">
                                <span>100</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item id="ddl-page-limit-4" @click="callComponentFetchData(1, 150)">
                                <span>150</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item id="ddl-page-limit-5" @click="callComponentFetchData(1, totalData)">
                                <span>Show All</span>
                            </vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>
                </div>

                <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
                <div class="flex flex-wrap items-center justify-between ag-grid-table-actions-right">
                    <!-- <vs-input class="mb-4 md:mb-0 mr-4" v-model="searchQuery" @input="updateSearchQuery"
                    placeholder="Search..."/>-->
                    <vs-button id="btn-add-merchant" v-if="validateRoles()" class="mb-4 md:mb-0 mr-4" icon="add" :to="'/merchant/new'">Add
                        Merchant
                    </vs-button>
                    <vs-button id="btn-add-submerchant" v-if="validateRoles()"
                               class="mb-4 md:mb-0 mr-4" icon="add" :to="'/merchant/sub/new'">Add Submerchant
                    </vs-button>
                    <!-- <vs-button class="mb-4 md:mb-0" @click="gridApi.exportDataAsCsv()">Export as CSV</vs-button> -->
                    <vs-button id="btn-export-csv" class="mb-4 md:mb-0" @click="gridApi.exportDataAsCsv()">Export as CSV</vs-button>
                </div>
            </div>
            <br><br>
            <vs-tabs :value="0">
                <vs-tab label="MERCHANT ">
                    <div>
                        <merchant-list :on-fetch-callback=fetchDataCallback></merchant-list>
                    </div>
                </vs-tab>
                <!--<vs-tab label="SUBMERCHANT ">
                    <div>
                        <submerchant-list :on-fetch-callback=fetchDataCallback></submerchant-list>
                    </div>
                </vs-tab>-->
            </vs-tabs>
        </vx-card>
    </div>
</template>

<script>
    import {AgGridVue} from "ag-grid-vue"
    import "@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss"
    import MerchantList from "./MerchantList"
    import SubmerchantList from "./SubmerchantList"

    export default {
        components: {
            AgGridVue,
            MerchantList,
            SubmerchantList
        },
        data() {
            return {
                gridApi: null,
                dataCount: 0,
                totalPage: 0,
                page: 1,
                limit: 20,
                totalData: 1,
                event: null
            }
        },
        computed: {
            currentPage: {
                get() {
                    if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
                    else return 1
                },
                set(val) {
                    this.fetchData(val, this.limit)
                }
            }
        },
        methods: {
            updateSearchQuery(val) {
                this.gridApi.setQuickFilter(val)
            },
            fetchDataCallback(payload) {
                this.dataCount = payload.dataCount
                this.totalPage = payload.totalPage
                this.totalData = payload.totalData
                this.page = payload.page
                this.limit = payload.limit
                this.gridApi = payload.gridApi
                this.event = payload.event
            },
            callComponentFetchData(page, limit) {
                const data = {
                    page: page,
                    limit: limit
                }

                this.$root.$emit(this.event, data)
            },
            validateRoles() {
                const role = localStorage.getItem("userRole")
                return (role == 'root' || role == 'administrator' || role == 'aino_cc')
            }
        }
    }
</script>